<template>
	<a-tooltip placement="top">
		<template slot="title">
			{{ $moment(item).format('LL') }}
		</template>

		<a-tag :color="$colors.blue">
			<fa-icon :icon="['far','clock']" />
			{{ $moment(item).format('DD/MM/YYYY') }}
		</a-tag>
	</a-tooltip>
</template>

<script>
export default {
	name: 'GTableSlotDate',
	props: {
		item: {
			type: String,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
